export const PHONE_NUMBER_REGEX = /^\d{10,11}$/;

export const isValidPhoneNumber = (value) => {
  if (value == null || value.trim() === "") return true;
  return PHONE_NUMBER_REGEX.test(value);
};
